import axios from "axios";
import { useOktaAuth } from "@okta/okta-react";

const currencySymbolMap = {
  INR: "₹",
  USD: "$",
  GBP: "£",
  EUR: "€",
  AED: "د.إ",
  SGD: "S$",
  AUD: "A$",
  CAD: "C$",
  JPY: "¥",
  CNY: "¥",
  KRW: "₩",
  BRL: "R$",
  MXN: "$",
  SAR: "﷼",
  THB: "฿",
  IDR: "Rp",
  MYR: "RM",
  VND: "₫",
  PHP: "₱",
};

export const getCurrencySymbol = (currency="INR") =>{
 return currencySymbolMap[currency] || currency;
}

export const formatNumberWestern = (value) => {
    const num = Number(value || 0);
    if (num >= 1_000_000_000) return `${(num / 1_000_000_000).toFixed(2)}B`;
    if (num >= 1_000_000) return `${(num / 1_000_000).toFixed(2)}M`;
    if (num >= 1_000) return `${(num / 1_000).toFixed(1)}K`;
    return num.toString();
  };
export const transformClientUserMap = (data) => {
  // All FileSource objects
  const sources = data.map(item => item.file_source_data).filter(Boolean);
  const uniqueById = (arr) => {
    return [...new Map(arr.map(item => [item.id, item])).values()];
  };

  const bm = uniqueById(
    sources.map(src => ({
      id: src.fb_bm_id,
      name: src.fb_bm_name || "",
    }))
  );

  const accounts = uniqueById(
    sources.map(src => ({
      id: src.fb_account_id,
      name: src.fb_account_name,
    }))
  );

  // Extract catalogs
  // const catalogs = sources.map(src => ({
  //   id: src.fb_catelog_id,
  //   name: src.fb_catelog_name,
  // }));
  
  const catalogs = [
    ...new Map(
      sources.map(src => [
        src.fb_catelog_id,
        {
          id: src.fb_catelog_id,
          name: src.fb_catelog_name,
        },
      ])
    ).values(),
  ];

  // Catalog list (list of pure catalog objects)
  // const catalogList = sources.map(src => ({
  //   name: src.fb_catelog_name,
  //   id: src.fb_catelog_id,
  // }));
  
  const catalogList = catalogs

  return { bm, accounts, catalogs, catalogList };
};

export const apiuserLogout = async function (oktaAuth) {
  // const { oktaAuth, authState } = useOktaAuth();
  await oktaAuth.signOut();
};
export const userLogout = async function (oktaAuth) {
  if (oktaAuth) {
    sessionStorage.clear();
    await oktaAuth.signOut();
  }
  else {
    const { oktaAuth, authState } = useOktaAuth();
    await oktaAuth.signOut();
  }
};

export const _createCookie = function (name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + date.toGMTString();
  } else var expires = "";
  document.cookie = name + "=" + value + expires + ";path=/";
};

export const _readCookie = function (name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
};

export const _eraseCookie = function (name) {
  _createCookie(name, "", -1);
};

export const getUserDetails = () => {
  try {
    const userDetails = JSON.parse(
      localStorage.getItem("okta-token-storage") || "{}"
    );
    const { name = null, email = null } = userDetails?.idToken?.claims || {};
    return { name, email }; // Return null values if name or email is missing
  } catch (error) {
    console.error("Error parsing token from localStorage:", error);
    return { name: null, email: null }; // Return null values on error
  }
};

export const refreshToken = async (oktaAuth) => {
  try {
    const accessToken = await oktaAuth.tokenManager.get("accessToken");

    if (!accessToken || accessToken.expiresAt * 1000 < Date.now()) {
      console.log("Access token expired, refreshing...");
      const newTokens = await oktaAuth.tokenManager.renew("accessToken"); // ⬅️ Refreshes token
      if (newTokens) {
        oktaAuth.tokenManager.setTokens(newTokens);
      }
      return newTokens;
    } else {
      console.log("Token is still valid");
      return false;
    }
  } catch (error) {
    console.error("Token refresh failed", error);
  }
};


export const getOktaToken = () => {
  const tokenStorage = localStorage.getItem("okta-token-storage");

  if (tokenStorage) {
    try {
      const token = JSON.parse(tokenStorage);
      return token.accessToken?.accessToken || null; // Safely access nested properties
    } catch (error) {
      console.error("Error parsing token from localStorage:", error);
      return null;
    }
  }

  return null; // Return null if no token is found
};
export const getFileSourceId = () => {
  const accountInfo = JSON.parse(
    sessionStorage.getItem("account_info" || "{}")
  );
  if (accountInfo && accountInfo.file_source_id) {
    return accountInfo.file_source_id;
  }
  else {
    const file_connect = JSON.parse(
    sessionStorage.getItem("file_connect" || "{}")
    );
    if (file_connect && file_connect[0].id) {
       return file_connect[0].id;
    }
    else {
    return false;
    }
  }
};
export const getFileSourceDetails = () => {
    const file_connect = JSON.parse(
    sessionStorage.getItem("file_connect" || "{}")
    );
    if (file_connect && file_connect[0]) {
       return file_connect[0];
    }
    else {
    return false;
    }
};
export const getSubCatalogId = () => {
  const accountInfo = JSON.parse(
    sessionStorage.getItem("account_info" || "{}")
  );
  if (accountInfo && accountInfo.sub_catelog) {
    return accountInfo.sub_catelog;
  }
};
export const setSubCatalogId = (sub_catalog_id) => {
  const accountInfo = JSON.parse(
    sessionStorage.getItem("account_info" || "{}")
  );
  accountInfo.sub_catelog = sub_catalog_id;
  sessionStorage.setItem("account_info", JSON.stringify(accountInfo));
};
export const setSubCatalogDetials = (details) => {
  const accountInfo = JSON.parse(
    sessionStorage.getItem("account_info" || "{}")
  );
  accountInfo.sub_catelog_details = details;
  sessionStorage.setItem("account_info", JSON.stringify(accountInfo));
};
export const getSubCatalogDetails= () => {
  const accountInfo = JSON.parse(
    sessionStorage.getItem("account_info" || "{}")
  );
  if (accountInfo && accountInfo.sub_catelog_details) {
    return accountInfo.sub_catelog_details;
  }
};

export const setCatlogList = (catalogs) => {

  // Retrieve the existing account_info or initialize an empty object
  const storedAccountInfo = sessionStorage.getItem("account_info");
  const accountInfo = storedAccountInfo ? JSON.parse(storedAccountInfo) : {};

  // Combine old and new catalogs, ensuring uniqueness
  const mergedCatalogs = [...(accountInfo.catalog_list || []), ...catalogs];

  // Use a Map to filter out duplicates based on catalog `id`
  const uniqueCatalogs = Array.from(
    new Map(mergedCatalogs.map((catalog) => [catalog.id, catalog])).values()
  );

  // Update account_info with unique catalogs
  accountInfo.catalog_list = uniqueCatalogs;

  // Store the updated object back in sessionStorage
  sessionStorage.setItem("account_info", JSON.stringify(accountInfo));
};

export const getCatlogList = () => {
  const accountInfo = JSON.parse(
    sessionStorage.getItem("account_info" || "{}")
  );
  if (accountInfo && accountInfo.catalog_list) {
    return accountInfo.catalog_list;
  }
};
export const getClientId = () => {
  const clientId = JSON.parse(
    sessionStorage.getItem("account_info" || "{}")
  );
  if (clientId && clientId.client) {
    return clientId.client || "";
  }
};
export const getApiCall = async (oktaAuth,url, data) => {
  try {
    const token = getOktaToken ? getOktaToken() : null; // Call getOktaToken() to retrieve the token
    // TODO Refresh token
    // const rToken = await refreshToken(oktaAuth)
    // if (rToken){
    //   token = rToken
    // }
    const response = await axios.get(url, {
      params: data,
      headers: {
        Authorizations: token ? `Bearer ${token}` : undefined, // Include token if it exists
      },
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401 
      // || error.response.status === 403
    ) {
      await apiuserLogout(oktaAuth); // Handle unauthorized error
    }
    console.error("Error occurred:", error);
    throw error; // Re-throw error for further handling
  }
};

export const postApiCall = async (oktaAuth,url, payload) => {
  try {
    const token = getOktaToken ? getOktaToken() : null;
    const response = await axios.post(url, payload, {
      headers: {
        Authorizations: token ? `Bearer ${token}` : undefined, // Optional if token is null
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401 
      // || error.response.status === 403
    ) {
      await apiuserLogout(oktaAuth);
    }
    console.error("Error occurred:", error);
    throw error;
  }
};

export const postApiCallFileUpload = async (oktaAuth,api_url, payload) => {
  var data = [];
  try {
    const token = getOktaToken ? getOktaToken() : null;
    var apidata = await axios.post(api_url, payload, {
      headers: {
        Authorizations: token ? `Bearer ${token}` : undefined,
        "Content-Type": "multipart/form-data",
      },
    });
    data = apidata;
    return data;
  } catch (error) {
    if (error.response && error.response.status === 401 
      // || error.response.status === 403
    ) {
      await apiuserLogout(oktaAuth);
    }
    console.error("Error occurred:", error);
    throw error;
  }
};

export const patchApiCall = async (oktaAuth,url, data) => {
  try {
    const token = getOktaToken ? getOktaToken() : null; // Call getOktaToken() to retrieve the token
    const response = await axios.patch(url, data, {
      headers: {
        Authorizations: token ? `Bearer ${token}` : undefined, // Include token if it exists
        "Content-Type": "application/json", // Specify content type for patch requests
      },
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401 
      // || error.response.status === 403
    ) {
      await apiuserLogout(oktaAuth);// Handle unauthorized error
    }
    console.error("Error occurred during PATCH request:", error);
    throw error; // Re-throw error for further handling
  }
};
